import React from 'react'

const Experience = () => (
  <svg viewBox="0 0 125 132.459">
    <path
      d="M152.945,71.531l-2.276.825a10.721,10.721,0,0,0-6.84,8.021l-.772,4.047a6.825,6.825,0,0,0,6.7,8.111h19.729a6.827,6.827,0,0,0,6.722-8.028l-.72-4.026a10.7,10.7,0,0,0-6.862-8.149l-2.413-.874V67.9a1.958,1.958,0,0,0-.024-.293,9.674,9.674,0,0,0,2.769-6.736v-5.3a9.381,9.381,0,0,0-18.762,0v5.464a9.356,9.356,0,0,0,2.764,6.621,1.952,1.952,0,0,0-.017.243Zm18.664,9.644.72,4.026a2.884,2.884,0,0,1-2.841,3.39H149.76a2.882,2.882,0,0,1-2.831-3.426l.772-4.047a6.758,6.758,0,0,1,4.311-5.056l1.491-.54c.037.038.075.077.115.113a9.094,9.094,0,0,0,11.921,0,1.946,1.946,0,0,0,.171-.171l1.573.57A6.742,6.742,0,0,1,171.609,81.175Zm-17.469-25.6a5.435,5.435,0,0,1,10.7-1.353c-.253.124-.513.241-.78.347-2.424.97-4.382.842-4.942.449a1.971,1.971,0,1,0-2.264,3.228,6.528,6.528,0,0,0,3.761,1.013,13.119,13.119,0,0,0,4.4-.838v2.452a5.709,5.709,0,0,1-1.71,4.048,5.51,5.51,0,0,1-1.7,1.14q-.065.025-.128.054a5.088,5.088,0,0,1-2.009.36,5.464,5.464,0,0,1-5.331-5.437ZM159.4,70.416l.18,0a9.147,9.147,0,0,0,2.7-.406v3.154a5.148,5.148,0,0,1-5.384,0V70.018A9.254,9.254,0,0,0,159.4,70.416Z"
      data-name="Path 395"
      transform="translate(-109.875 -34.051)"
    />
    <path
      d="M82.735,339.847h61.394a1.971,1.971,0,0,0,0-3.943H82.735a1.971,1.971,0,0,0,0,3.943Z"
      data-name="Path 396"
      transform="translate(-63.325 -249.045)"
    />
    <path
      d="M82.735,380.288h61.394a1.971,1.971,0,1,0,0-3.943H82.735a1.971,1.971,0,1,0,0,3.943Z"
      data-name="Path 397"
      transform="translate(-63.325 -279.028)"
    />
    <path
      d="M82.735,420.727h61.394a1.971,1.971,0,0,0,0-3.943H82.735a1.971,1.971,0,0,0,0,3.943Z"
      data-name="Path 398"
      transform="translate(-63.325 -309.352)"
    />
    <path
      d="M82.735,461.168h61.394a1.971,1.971,0,0,0,0-3.943H82.735a1.971,1.971,0,0,0,0,3.943Z"
      data-name="Path 399"
      transform="translate(-63.325 -339.163)"
    />
    <path
      d="M80.764,257a1.971,1.971,0,0,0,1.971,1.971h61.394a1.971,1.971,0,0,0,0-3.943H82.735A1.971,1.971,0,0,0,80.764,257Z"
      data-name="Path 400"
      transform="translate(-63.325 -189.079)"
    />
    <path
      d="M82.735,299.407h61.394a1.971,1.971,0,1,0,0-3.943H82.735a1.971,1.971,0,1,0,0,3.943Z"
      data-name="Path 401"
      transform="translate(-63.325 -219.062)"
    />
    <path
      d="M55.02,339.833a1.979,1.979,0,1,0-1.979-1.979A1.979,1.979,0,0,0,55.02,339.833Z"
      data-name="Path 402"
      transform="translate(-42.888 -249.024)"
    />
    <path
      d="M55.02,258.953a1.979,1.979,0,1,0-1.979-1.979A1.979,1.979,0,0,0,55.02,258.953Z"
      data-name="Path 403"
      transform="translate(-42.888 -189.058)"
    />
    <path
      d="M55.02,299.393a1.979,1.979,0,1,0-1.979-1.979A1.979,1.979,0,0,0,55.02,299.393Z"
      data-name="Path 404"
      transform="translate(-42.888 -219.041)"
    />
    <path
      d="M55.02,380.273a1.979,1.979,0,1,0-1.979-1.979A1.979,1.979,0,0,0,55.02,380.273Z"
      data-name="Path 405"
      transform="translate(-42.888 -279.007)"
    />
    <path
      d="M55.02,420.714a1.979,1.979,0,1,0-1.979-1.979A1.979,1.979,0,0,0,55.02,420.714Z"
      data-name="Path 406"
      transform="translate(-42.888 -309.332)"
    />
    <path
      d="M55.02,461.154a1.979,1.979,0,1,0-1.979-1.979A1.979,1.979,0,0,0,55.02,461.154Z"
      data-name="Path 407"
      transform="translate(-42.888 -339.143)"
    />
    <path
      d="M136.323,30.559a13.414,13.414,0,0,1-1.881-2.79,14.141,14.141,0,0,1-.7-3.464c-.282-2.282-.6-4.869-2.407-6.674s-4.392-2.125-6.675-2.407a14.146,14.146,0,0,1-3.465-.7,13.4,13.4,0,0,1-2.79-1.88,14.616,14.616,0,0,0-4.637-2.8V9.26A9.271,9.271,0,0,0,104.509,0H23.677a9.271,9.271,0,0,0-9.261,9.26V16.75a1.94,1.94,0,0,0,3.881,0V9.261a5.386,5.386,0,0,1,5.381-5.38h80.832a5.386,5.386,0,0,1,5.381,5.38v.587a14.621,14.621,0,0,0-4.636,2.8,13.419,13.419,0,0,1-2.79,1.88,14.17,14.17,0,0,1-3.465.7c-2.282.282-4.869.6-6.675,2.407s-2.125,4.392-2.408,6.674a14.145,14.145,0,0,1-.7,3.464,13.4,13.4,0,0,1-1.881,2.79c-1.45,1.835-3.093,3.914-3.093,6.576s1.643,4.741,3.093,6.576a13.414,13.414,0,0,1,1.881,2.79,14.142,14.142,0,0,1,.7,3.464c.282,2.282.6,4.869,2.407,6.674S96.717,58.763,99,59.045c.68.084,1.34.167,1.949.28V88.655A2.979,2.979,0,0,0,105.765,91l4.125-3.229V123.2a5.386,5.386,0,0,1-5.381,5.38H23.677A5.386,5.386,0,0,1,18.3,123.2v-97.9a1.94,1.94,0,1,0-3.881,0v97.9a9.271,9.271,0,0,0,9.261,9.26h80.832a9.271,9.271,0,0,0,9.261-9.26V87.771L117.9,91a2.981,2.981,0,0,0,4.819-2.345V67a1.94,1.94,0,0,0-3.881,0V86.807l-5.158-4.038a2.983,2.983,0,0,0-3.684-.007L104.829,86.8V61.29l.426.335c1.835,1.45,3.914,3.092,6.576,3.092s4.741-1.643,6.576-3.092a13.422,13.422,0,0,1,2.79-1.881,14.17,14.17,0,0,1,3.465-.7c2.282-.282,4.869-.6,6.675-2.407s2.125-4.392,2.407-6.674a14.156,14.156,0,0,1,.7-3.464,13.4,13.4,0,0,1,1.881-2.79c1.45-1.835,3.093-3.914,3.093-6.576s-1.643-4.741-3.093-6.576ZM133.279,41.3a16.256,16.256,0,0,0-2.42,3.709,17.064,17.064,0,0,0-.966,4.475c-.225,1.823-.438,3.545-1.3,4.406s-2.584,1.074-4.407,1.3a17.07,17.07,0,0,0-4.475.966A16.254,16.254,0,0,0,116,58.579c-1.469,1.16-2.857,2.257-4.171,2.257s-2.7-1.1-4.171-2.257a16.263,16.263,0,0,0-3.709-2.42c-.094-.039-.419-.162-.489-.184a19.3,19.3,0,0,0-3.987-.782c-1.823-.225-3.545-.438-4.407-1.3s-1.074-2.583-1.3-4.406a17.068,17.068,0,0,0-.966-4.475,16.264,16.264,0,0,0-2.42-3.709c-1.16-1.469-2.257-2.856-2.257-4.17s1.1-2.7,2.257-4.17a16.255,16.255,0,0,0,2.42-3.709,17.054,17.054,0,0,0,.966-4.475c.225-1.823.438-3.545,1.3-4.406s2.584-1.074,4.407-1.3a17.07,17.07,0,0,0,4.475-.966,16.254,16.254,0,0,0,3.709-2.42c1.466-1.158,2.851-2.252,4.163-2.256h.015c1.312,0,2.7,1.1,4.163,2.256a16.263,16.263,0,0,0,3.709,2.42,17.06,17.06,0,0,0,4.475.966c1.823.225,3.545.438,4.407,1.3s1.074,2.583,1.3,4.406a17.066,17.066,0,0,0,.966,4.475,16.263,16.263,0,0,0,2.42,3.709c1.16,1.469,2.257,2.856,2.257,4.17S134.439,39.836,133.279,41.3Z"
      data-name="Path 408"
      transform="translate(-14.416)"
    />
    <path
      fill="#0047BA"
      d="M363.036,95.037l-6.708-1.9-3.879-5.793a2.49,2.49,0,0,0-4.138,0l-3.879,5.793-6.709,1.9a2.49,2.49,0,0,0-1.279,3.936l4.312,5.479-.268,6.965a2.488,2.488,0,0,0,3.347,2.434l6.544-2.407,6.543,2.407a2.49,2.49,0,0,0,3.348-2.432L360,104.451l4.312-5.479a2.49,2.49,0,0,0-1.279-3.936Zm-6.463,7.4a2.494,2.494,0,0,0-.53,1.635l.2,5.332-5.008-1.842a2.493,2.493,0,0,0-1.72,0l-5.009,1.843.2-5.333a2.5,2.5,0,0,0-.532-1.634l-3.3-4.193,5.136-1.453a2.494,2.494,0,0,0,1.39-1.011l2.969-4.434,2.969,4.434a2.5,2.5,0,0,0,1.392,1.011l5.135,1.452Z"
      data-name="Path 409"
      transform="translate(-253.406 -64.022)"
    />
  </svg>
)

export default Experience
